import { format, isSameMonth } from "date-fns";
import React from "react";

import {
  Box,
  Text,
  Pressable,
} from "@whoosh/design-system/src/components/primitive";

import { CalendarMonthProps } from "../types";

interface WeekDayProps extends CalendarMonthProps {
  curDateObj: Date;
}

export const WeekDay = (props: WeekDayProps) => {
  const { curDateObj, monthDateObj, onDatePress, styledDates } = props;
  const isDateInCurrentMonth = isSameMonth(curDateObj, monthDateObj);
  const dateSearchString = format(curDateObj, "yyyy-MM-dd");
  const isSelected = styledDates?.selectedDates.includes(dateSearchString);
  const isHighLighted =
    styledDates?.highlightedDates.includes(dateSearchString);

  return (
    <Box alignItems="center" justifyContent="center" flex={1}>
      {isDateInCurrentMonth ? (
        <Pressable
          onPress={() => {
            onDatePress(format(curDateObj, "yyyy-MM-dd"));
          }}
        >
          <Box
            alignItems="center"
            justifyContent="center"
            minWidth={40}
            minHeight={40}
            borderRadius="2"
            bg={
              isSelected
                ? "button-main-surface-neutral"
                : isHighLighted
                ? "main-primary-200"
                : "transparent"
            }
          >
            <Text
              maxFontSizeMultiplier={2}
              color={isSelected ? "text-inverse" : "black"}
            >
              {format(curDateObj, "d")}
            </Text>
          </Box>
        </Pressable>
      ) : null}
    </Box>
  );
};
